import { styled } from 'goober';
import { forwardRef } from 'react';
export var MCEWrap = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        background: '#fff',
        border: "1px solid ".concat(theme.colors.neutral.w200),
        boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)',
        borderRadius: '6px',
        padding: '20px 8px 10px',
        minHeight: '400px',
        width: '360px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 101,
    });
});
export var MCEHeader = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '0px 12px 10px',
        display: 'flex',
        justifyContent: 'space-between',
    });
});
export var MCERow = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $active = _a.$active, $isDraggingOver = _a.$isDraggingOver;
    return ({
        width: '100%',
        padding: '5px 12px',
        borderRadius: '4px',
        background: $active ? ($isDraggingOver ? theme.colors.neutral.w300 : theme.colors.neutral.w50) : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    });
});
export var MCERowInner = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return ({
        color: theme.colors.neutral.w700,
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: $active ? '3px 8px' : '5px 10px',
        border: "".concat($active ? '2px' : '1px', " solid ").concat($active ? theme.colors.primary.w500 : theme.borderColor),
        marginRight: $active ? '10px' : '0px',
        borderRadius: '4px',
        minHeight: '36px',
    });
});
export var MCERowInfoLabel = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.neutral.w700,
    });
});
export var MCEFooter = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 0px 0px',
    });
});
